"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _withoutIndex;
function _withoutIndex(iteratee) {
    return (value, index, callback) => iteratee(value, callback);
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/async/internal/withoutIndex.js
// module id = 3H24
// module chunks = 0